<template>
    <div class="mainClass">
      <!-- Buttons to trigger modals -->
      <div class="buttonGroup">
        <button type="button" class="btn btn-primary mb-2" data-bs-toggle="modal" data-bs-target="#registerTeacherModal">
          Register Teacher
        </button>
        <button type="button" class="btn btn-secondary mb-2" data-bs-toggle="modal" data-bs-target="#addSubjectModal">
          Add Subject
        </button>
        <button type="button" class="btn btn-secondary mb-2" data-bs-toggle="modal" data-bs-target="#addStudentLevelModal">
          Add Studentn Level
        </button>
        <button type="button" class="btn btn-secondary mb-2" data-bs-toggle="modal" data-bs-target="#addPackageModal">
          Add Package
        </button>
      </div>
  
      <!-- Institute Registration Modal -->
      <div class="modal fade" id="registerTeacherModal" tabindex="-1" aria-labelledby="registerTeacherModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="registerTeacherModalLabel">Teacher Registration</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <InsertTeacher  @teacherAdded="fetchTeachers"/>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Add Location Modal -->
      <div class="modal fade" id="addSubjectModal" tabindex="-1" aria-labelledby="addSubjectModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="addSubjectModalLabel">Add Location</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <InsertSubject />
            </div>
          </div>
        </div>
      </div>


      <!-- Add Student Level Modal -->
      <div class="modal fade" id="addStudentLevelModal" tabindex="-1" aria-labelledby="addStudentLevelModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="addStudentLevelModalLabel">Add Student Level</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <InsertStudentLevel />
            </div>
          </div>
        </div>
      </div>


      <!-- Add Student Level Modal -->
      <div class="modal fade" id="addPackageModal" tabindex="-1" aria-labelledby="addPackageModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="addPackageModalLabel">Add Package</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <InsertPackage />
            </div>
          </div>
        </div>
      </div>
  <p class="text-center mt-2">Total Teachers: {{ totalTeachers }}</p>

      <!-- Institute Table -->
      <div class="container mt-4">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead class="thead-dark">
              <tr>
                <th>ID</th>
                <th>Teacher Name</th>
                <th>Address</th>
                <!-- <th>Contact</th> -->
                <th>Email</th>
                <th>View</th>
                <th>More</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="teacher in teachers" :key="teacher.id">
                <td>{{ teacher.id }}</td>
                <td>{{ teacher.user ? teacher.user.first_name : 'N/A' }}</td>
                <td>{{ teacher.address }}</td>
                <!-- <td>{{ teacher.teach_institute && teacher.teach_institute.institute ? teacher.teach_institute.institute.institute_name : 'N/A' }}</td> -->
                <!-- <td>{{ teacher.contact }}</td> -->
                <td>{{ teacher.user ? teacher.user.email : 'N/A' }}</td>
                <td>
                  <button @click="viewTeacherDetails(teacher.id)" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#showTeacherModal">
                    <i class="bi bi-eye"></i> View
                  </button>
                </td>

                <td>
                  <button @click="moreTeacherDetails(teacher.id)" class="btn btn-outline-primary btn-sm">
                    <i class="bi bi-three-dots"></i> More
                  </button>
                </td>

                <td>
                  <button @click="editTeacherDetails(teacher.id)" class="btn btn-outline-warning btn-sm" data-bs-toggle="modal" data-bs-target="#editTeacherModal">
                    <i class="bi bi-pencil"></i> Edit
                  </button>
                </td>
                <td>
                  <button @click="deleteTeacher(teacher.id)" class="btn btn-outline-danger btn-sm">
                    <i class="bi bi-trash"></i> Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Loading Spinner -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <nav class="mt-4">
  <ul class="pagination justify-content-center">
    <li class="page-item" :class="{ disabled: currentPage === 1 }">
      <button class="page-link" @click="changePage(currentPage - 1)">Previous</button>
    </li>

    <li
      class="page-item"
      v-for="page in totalPages"
      :key="page"
      :class="{ active: currentPage === page }"
    >
      <button class="page-link" @click="changePage(page)">
        {{ page }}
      </button>
    </li>

    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
      <button class="page-link" @click="changePage(currentPage + 1)">Next</button>
    </li>
  </ul>
</nav>

        </div>
      </div>
  
      <!-- Modal View -->
      <div class="modal fade" id="showTeacherModal" tabindex="-1" aria-labelledby="showTeacherModalLabel">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="showTeacherModalLabel">Teacher Details</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <ViewTeacher :teacher="selectedTeacher" />
            </div>
          </div>
        </div>
      </div>
  
      <!-- Modal Edit -->
      <div class="modal fade" id="editTeacherModal" tabindex="-1" aria-labelledby="editTeacherModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="editTeacherModalLabel">Edit Teacher</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <EditTeacher :teacher="selectedTeacherEdit"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import InsertTeacher from '@/components/Teacher/InsertTeacher.vue';
  import InsertSubject from '@/components/Teacher/InsertSubject.vue';
  import EditTeacher from '@/components/Teacher/EditTeacher.vue';
  import ViewTeacher from '@/components/Teacher/ViewTeacher.vue';

  import InsertStudentLevel from '@/components/Teacher/InsertStudentLevel.vue';
  import InsertPackage from '@/components/Teacher/InsertPackage.vue';

  import axios from 'axios';


  
  export default {
    name: 'teacherTable',
    components: {
      InsertTeacher,
      InsertSubject,
      EditTeacher,
      ViewTeacher,
      InsertStudentLevel,
      InsertPackage,
    },
    data() {
      return {
        loading: true, // Initial state
        teachers: [],
        selectedTeacher: null, // Store the selected institute details here
        selectedTeacherEdit: null,

         currentPage: 1,
    perPage: 2,
    totalPages: 0,
    totalTeachers: 0,
      };
    },
    mounted() {
      this.fetchTeachers();
    },
    methods: {
      // async fetchTeachers() {
      //   this.loading = true;
      //   try {
      //     const response = await axios.get('/get-teachers');
      //     this.teachers = response.data;
      //   } catch (error) {
      //     console.error('Error fetching teachers:', error);
      //   } finally {
      //   this.loading = false;
      // }
      // },

      async fetchTeachers() {
  this.loading = true;
  try {
    const response = await axios.get('/get-teachers', {
      params: {
        page: this.currentPage,
        per_page: this.perPage,
      },
    });
    this.teachers = response.data.data;
    this.totalPages = response.data.last_page;
    this.totalTeachers = response.data.total;
  } catch (error) {
    console.error('Error fetching teachers:', error);
  } finally {
    this.loading = false;
  }
},

changePage(page) {
  if (page >= 1 && page <= this.totalPages) {
    this.currentPage = page;
    this.fetchTeachers();
  }
},



      async editTeacherDetails(id) {
      try {
        const response = await axios.get(`/get-teacher-by-id/${id}`);
        this.selectedTeacherEdit = response.data;
      } catch (error) {
        console.error('Error fetching teacher details for edit:', error);
        this.selectedTeacherEdit = null;
      }
    },

    async deleteTeacher(id) {
      try {
        await axios.delete(`/delete-teacher/${id}`);
        this.teachers = this.teachers.filter(teacher => teacher.id !== id);
        alert('Teacher deleted successfully');
      } catch (error) {
        console.error('Error deleting Teacher:', error);
        alert('Failed to delete teacher');
      }
    },
  
      // async deleteInstitute(id) {
      //   try {
      //     await axios.delete(`/delete-institutes/${id}`);
      //     this.institutes = this.institutes.filter(institute => institute.id !== id);
      //     alert('Institute deleted successfully');
      //   } catch (error) {
      //     console.error('Error deleting institute:', error);
      //     alert('Failed to delete institute');
      //   }
      // },
  
      async viewTeacherDetails(id) {
        try {
          const response = await axios.get(`/get-teacher-by-id/${id}`);
          this.selectedTeacher = response.data;
        } catch (error) {
          console.error('Error fetching teachers details:', error);
          this.selectedTeacher = null;
        }
      },
      moreTeacherDetails(id) {
  // Navigate to the more details page using query parameters
  this.$router.push({ name: 'MoreTeacherDetails', query: { teacherId: id } });
},
  
      // async editInstituteDetails(id) {
      //   try {
      //     const response = await axios.get(`/get-institute-by-id/${id}`);
      //     this.selectedInstituteEdit = response.data;
      //   } catch (error) {
      //     console.error('Error fetching institute details for edit:', error);
      //     this.selectedInstituteEdit = null;
      //   }
      // },
    },
  };
  </script>
  
  <style scoped>
  .mainClass {
    width: 100%;
    height: 100%;
  }
  .table th,
  .table td {
    text-align: center;
    vertical-align: middle;
  }
  .buttonGroup {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 60px;
  }
  .table-responsive {
    max-width: 100%;
    overflow-x: auto;
  }
  @media (max-width: 768px) {
    .modal-dialog-centered {
      max-width: 100%;
      margin: 0;
    }
    .buttonGroup {
      width: 100%;
      height: 100%;
      display: inline-block;
      align-items: center;
      justify-content: center;
      padding: 10px 50px;
    }
    .btn {
      width: 100%;
      margin-bottom: 5px;
    }
    .modal-content {
      padding: 10px;
    }
    .table-responsive {
      display: flex;
      justify-content: center;
      align-items: center;
      overflow-x: scroll;
      max-width: 75svw;
    }
  }
  </style>
  